const appConstants = {
    // The name of the cookie that stores the user's authentication token
    authCookieName: 'fleet_app_auth',

    // The name of the cookie that stores the user's authentication token
    tokenCookieName: 'fleet_app_token',

    // The name of the cookie that stores the user's authentication token
    forgotPasswordCookieName: 'fleet_app_forgot_password',

    // The name of the storage used to store otp countdown
    otpCountdownStorageName: 'fleet_app_otp_countdown',

    // The name of the storage used to store the selected issues
    selectedIssuesStorageName: 'fleet_app_selected_issues',

    // The name of the storage used to store the vehicle id
    vehicleIdStorageName: 'fleet_app_vehicle_id',

    // The name of the storage used to store the selected service reminders
    selectedServiceReminderStorageName: 'fleet_app_selected_service_reminders',
};

export default appConstants;
